
import Create from './views/Create.svelte';
import Receive from './views/Receive.svelte';
import Link from './views/Link.svelte';
import Burned from './views/Burned.svelte';

const routes = {
    '/': Create,
    '/l/:token/:secret': Link,
    '/r/:token/:secret': Receive,
    '/burned': Burned,
    '*': Create,
};

export { routes }